export const getTitle = mediaModel => {
  const mediaType = mediaModel.get("mediaType");

  if (
    mediaType === "anthology" ||
    mediaType === "collection" ||
    mediaType === "module"
  ) {
    return mediaModel.get("name");
  } else if (mediaType === "content" || mediaType === "curation") {
    return mediaModel.get("title");
  } else {
    throw new Error(
      `Cannot determine title for curation media tile, media type: ${mediaType}`,
    );
  }
};

export const getThumbnailUrl = mediaModel => {
  const mediaType = mediaModel.get("mediaType");

  if (
    mediaType === "anthology" ||
    mediaType === "collection" ||
    mediaType === "module"
  ) {
    return mediaModel.get("iconUrl");
  } else if (mediaType === "content" || mediaType === "curation") {
    if (mediaModel.get("type") === "AUDIO") {
      return "";
    } else {
      return mediaModel.get("thumbnailUrl");
    }
  } else {
    throw new Error(
      `Cannot determine thumbnail for curation media tile, media type: ${mediaType}`,
    );
  }
};

export const getDetailUrl = mediaModel => {
  const mediaType = mediaModel.get("mediaType");
  const mediaId = mediaModel.get("id");

  if (mediaType === "content") {
    return `/content/${mediaId}`;
  } else if (mediaType === "anthology") {
    const typeLabel = mediaModel.get("typeLabel").toLowerCase();
    return `/${typeLabel}/${mediaId}`;
  } else if (mediaType === "collection") {
    const anthologyTypeLabel = mediaModel
      .get("anthology")
      .typeLabel.toLowerCase();
    const collectionTypeLabel = mediaModel.get("typeLabel").toLowerCase();
    const anthologyId = mediaModel.get("anthology").id;
    return `/${anthologyTypeLabel}-${collectionTypeLabel}/${anthologyId}/${mediaId}`;
  } else if (mediaType === "module") {
    const internalCode = mediaModel.get("internalCode");
    return `/module/${internalCode}`;
  } else if (mediaType === "curation") {
    return `/curation/${mediaId}`;
  } else {
    throw new Error(
      `Cannot determine detail URL for curation media tile, media type: ${mediaType}`,
    );
  }
};

export const getDownloadUrl = mediaModel => {
  const mimeType = mediaModel.get("mimeType");
  const contentType = mediaModel.get("type");

  let downloadUrl;

  if (contentType === "IMAGE") {
    downloadUrl = mediaModel.get("imageUrl");
  } else if (mimeType === "image/jpeg" || mimeType === "application/pdf") {
    downloadUrl = mediaModel.get("pdfUrl");
  } else if (mimeType === "application/epub+zip") {
    downloadUrl = mediaModel.get("epubFileUrl");
  }

  if (typeof downloadUrl === "string") {
    return downloadUrl.replace("content", "external_content");
  } else {
    return null;
  }
};
